module.exports = __webpack_public_path__ + "static/media/landing-tab-notifications-m.2fee238e.svg";